import React, { memo } from 'react'
import RadialSpinner from 'transfix-ui/components/RadialSpinner'
import { Box, Typography } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { FullPageOverlay } from 'apps/fleet-planner/components/modals/full-page-overlay/FullPageOverlay'

interface IBidSubmitModalProps {
  isOpen: boolean
  onClose: () => void
}

export const BidSubmitModal = memo<IBidSubmitModalProps>(({ isOpen, onClose }) => {
  const { isMobile } = useBreakpointContext()

  return (
    <FullPageOverlay
      isOpen={isOpen}
      onClose={onClose}
      fullScreen={isMobile}
      showContentDividers={isMobile}
      maxWidth='sm'>
      <Box
        data-test='bid-submit-modal'
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        textAlign='center'
        p={4}>
        <RadialSpinner position='relative' />
        <Box mt={4}>
          <Typography variant='subtitle1'>Submitting Your Bid</Typography>
        </Box>
        <Box mt={4}>
          <Typography variant='body2'>
            Hang tight. We are analyzing and submitting your bid.
          </Typography>
        </Box>
      </Box>
    </FullPageOverlay>
  )
})
